import React, { Component } from 'react'
import PropTypes from 'prop-types';
import './styles.css';
import $ from 'jquery';

export class Multiselect extends Component {
    constructor(props) {
        super(props);
		this.opnDrpwn =this.opnDrpwn.bind(this);
        this.state ={
            checked: [],
            dropDownValue: []
          }
          this.checkBox = this.checkBox.bind(this);
    }
    componentWillMount() {
        this.setState({
            dropDownValue: this.props.options
        });
    }
    removeChip(value) {
        this.checkBox(value, false);
    }
	
    checkBox(value, condition, name) {
		
        let checkedValue = this.state.checked;
        if(condition) {
			$('.search-result').attr('style')
            checkedValue.push({data_value:value,data_name:name});
        } else {
            let index = checkedValue.indexOf(value);
            checkedValue.splice(index, 1);
        }
        this.setState({
            checked: checkedValue
        }, () => {
            this.props.onSelectOptions(this.state.checked); 
        });
    }
	
    searchFun(e) {
        if(e.target.value.length !== 0) {
            let enteredValue = e.target.value;
            let presentValue = this.props.options.filter(function(data) {
                return data.name.indexOf(enteredValue) > -1;
            })
            this.setState({dropDownValue: presentValue})
        } else {
            this.setState({dropDownValue: this.props.options})
        }
    }
    returnChip() {
        const chip = this.state.checked ? this.state.checked.map((data, index) =>
            <div className="chip-body" key={index}>
                <p className="chip-text">{data.data_name}</p>
                <button className="chip-close" onClick={e => this.removeChip(data)}>&times;</button>
            </div>
        ) : []
        return chip;
    }
    returnList() {
        const list = this.state.dropDownValue ? this.state.dropDownValue.map((data, index) =>
        <label className="container" key={index} id={"labl_"+data.value}>{data.name}
        <input type="checkbox" value={data.value} id={data.name} data-chk={"chk_"+data.value} onChange={e => this.checkBox(e.target.value, e.target.checked, e.target.id)} checked ={this.state.checked.some(person => person.data_value === data.value) ? true : false} />
        <span className="checkmark"></span>
    </label>
        ) : null;
        return list;
    }
	
	opnDrpwn(){
		$('.search-result').show();
	}
    render() {
        return (
            <div className="multiSelect">
                <div className="chip" onClick={this.opnDrpwn}>
                    {this.returnChip()}
                </div>
                <input type="text" name="Search" placeholder="Nothing selected" className="input-box form-control" onChange={e => this.searchFun(e)} id="shwDrpwnclk"/>
				
                <div className="search-result">
                    <input type="text" name="Search" placeholder="Search" className="input-box form-control" onChange={e => this.searchFun(e)} />
					<div className="list-result">
                        {this.returnList()}
                    </div>
                </div>
            </div>
        )
    }
}

Multiselect.defaultProps = {
    options: []
}

/** define proptypes including fields which is required */
Multiselect.prototypes = {
    options: PropTypes.array.isRequired,
    onSelectOptions: PropTypes.func
}

export default Multiselect;
